import React from 'react'
import { DescriptionItem } from '../../../../components/DescriptionItem'
import './index.less'

const clsPrefix = 'c-basic-show-card'
const BasicShowCard: React.FC<{
  title: string[],
  descriptions: string[],
  iconStyle: React.CSSProperties
}> = ({
  title = [],
  descriptions = [],
  iconStyle = {}
}) => {
  return (
    <div className={clsPrefix}>
      <div className={`${clsPrefix}__content`}>
        <div className={`${clsPrefix}__title`}>
          <div className={`${clsPrefix}__title__name`}>
          {
            title && title.map((text,index) => (
              <p key={index}>{text}</p>
            ))
          }
          </div>
        </div>
        <div className={`${clsPrefix}__descriptions`}>
          {
            descriptions && descriptions.map(((item, index) => (
              <DescriptionItem
                key={index}
                content={item}
                className='basic-desc'
                iconName='raw-right'
                iconStyle={iconStyle}
                iconClassName='desc-icon'
              />
            )))
          }
        </div>
      </div>
    </div>
  )
}

export { BasicShowCard }
